import React from "react";

interface IValidationErrorProps {
    message?: string;
};

const ValidationError = ({message}: IValidationErrorProps) => 
    <label className="validation-error">{message}</label>;

export { ValidationError };